module.exports = "/assets/data/feeea5bae3c49a0097ec95399c2401f7-SM5.data.json";